import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getDocuments = (customerId, personId)  =>
    createAction("GET_DOCUMENTS_FOR_PERSON", () =>
        Axios.get(`/api/customer/${customerId}/person/${personId}/documents?limit=1000`).then(data => ({
            personId: personId,
            documents: data.data,
        }))
    );

export const deleteDocument = (customerId, personId, documentId) =>
    createAction("DELETE_DOCUMENT_FOR_PERSON", () =>
        Axios.delete(`/api/customer/${customerId}/person/${personId}/document/${documentId}`).then(() => {
            return {
                personId: personId,
                documentId: documentId,
            };
        })
    );
